import { Box, SxProps } from '@mui/system';
import Carousel, { CarouselElementState } from 'Components/Carousel';

type NativigationProps = {
  onNext: () => void;
  onBack: () => void;
  sx?: SxProps;
  nextButtonSx?: SxProps;
  backButtonSx?: SxProps;
  nextText?: string;
  backText?: string;
  carousel?: CarouselElementState[];
};

const Navigation = ({
  sx = {},
  nextButtonSx = {},
  backButtonSx = {},
  onNext,
  onBack,
  nextText,
  backText,
  carousel,
}: NativigationProps) => {
  const gridTemplateColumns = carousel
    ? '[col1-start] 40%  [col2-start] 20%  [col3-start] 40% [col3-end]'
    : '[col1-start] 50%  [col2-start] 50%  [col2-end]';

  return (
    <Box
      sx={{
        width: '90%',
        display: 'grid',
        gridTemplateColumns: gridTemplateColumns,
        position: 'relative',
        ...sx,
      }}
    >
      <Box
        sx={{
          marginLeft: { xs: '8px', md: '30px' },
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: { xs: '4px 6px', md: '8px' },
          gap: '8px',
          width: { xs: '90px', sm: '120px', md: '160px' },
          height: { xs: '20px', md: '24px' },
          outlineColor: '#CA7C62',
          outlineStyle: 'solid',
          borderRadius: '40px',
          '&:hover': {
            cursor: 'pointer',
          },
          ...backButtonSx,
        }}
        onClick={onBack}
      >
        <Box
          sx={{
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: { xs: '8px', sm: '11px', md: '14px' },
            lineHeight: { xs: '14px', md: '19px' },
            textAlign: 'center',
            letterSpacing: { xs: '1.5px', md: '2.5px' },
            textTransform: 'uppercase',
            color: '#CA7C62',
          }}
        >
          {backText}
        </Box>
      </Box>

      {carousel && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Carousel carousels={carousel} />
        </Box>
      )}

      <Box
        sx={{
          marginLeft: 'auto',
          marginRight: { xs: '8px', md: '30px' },
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: { xs: '4px 6px', md: '8px 8px' },
          gap: '8px',
          width: { xs: '70px', sm: '80px', md: '100px' },
          height: { xs: '20px', md: '28px' },
          background: '#CA7C62',
          borderRadius: '40px',
          '&:hover': {
            cursor: 'pointer',
          },
          ...nextButtonSx,
        }}
        onClick={onNext}
      >
        <Box
          sx={{
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: { xs: '8px', sm: '11px', md: '14px' },
            lineHeight: { xs: '14px', md: '19px' },
            textAlign: 'center',
            letterSpacing: { xs: '1.5px', md: '2.5px' },
            textTransform: 'uppercase',
            color: '#050B13',
            width: 'auto',
            padding: { xs: '4px', md: '8px' },
          }}
        >
          {nextText}
        </Box>
      </Box>
    </Box>
  );
};

export default Navigation;
